import React, { FunctionComponent, useState } from 'react';
import { useSelector } from 'react-redux';
import Modal from 'react-modal';

import { RootStore } from '../app/types';
import { Login } from './Login';

Modal.setAppElement('#root');

const modalStyle = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: 12,
        padding: 0,
        border: 'none',
        boxShadow: '0 4px 24px rgba(0, 0, 0, 0.15)',
        minWidth: 320,
        maxWidth: '90vw',
    },
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1000,
    }
};

export const Footer: FunctionComponent = () => {
    const [modalIsOpen, setIsModalOpen] = useState(false);
    const isLoggedIn = useSelector((state: RootStore) => state.loggedInUser !== null);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const year = new Date().getFullYear();

    return (
        <footer
            style={{
                padding: '24px 16px',
                marginTop: 'auto',
                textAlign: 'center',
            }}
        >
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style={modalStyle}
                contentLabel="Login Modal"
            >
                <div>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '16px 20px',
                        borderBottom: '1px solid #eee',
                    }}>
                        <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 600 }}>
                            {isLoggedIn ? 'Account' : 'Sign In'}
                        </h3>
                        <button
                            onClick={closeModal}
                            style={{
                                background: 'none',
                                border: 'none',
                                fontSize: '1.5rem',
                                cursor: 'pointer',
                                color: '#999',
                                lineHeight: 1,
                            }}
                        >
                            &times;
                        </button>
                    </div>
                    <div style={{ padding: 20 }}>
                        <Login onLoginOk={closeModal} />
                    </div>
                </div>
            </Modal>

            <span style={{ color: '#999', fontSize: '0.75rem' }}>
                © {year} Big Little Idea ·{' '}
                <span
                    onClick={openModal}
                    style={{ cursor: 'pointer' }}
                >
                    {isLoggedIn ? 'Account' : 'Admin'}
                </span>
            </span>
        </footer>
    );
};
